import app from 'flarum/forum/app';

import Discussion from 'flarum/common/models/Discussion';

import { ShareIconButton, doesSupportWebShare } from '@davwheat-share';

export default function shareButton(discussion: Discussion) {
  if (!('davwheat-share' in flarum.extensions)) return null;

  if (!doesSupportWebShare()) return null;

  return <ShareIconButton url={`${app.forum.attribute('baseUrl')}/d/${discussion.slug()}`} discussionTitle={discussion.title()} />;
}
